<template>
  <div id="scrollTo">
    <div class="d-flex jc-center">
      <span v-if="step !== 2" class="dot-title">
        {{ $t("detail.title") }}
      </span>
      <span v-else class="dot-title">
        {{ $t("detail.orderComplete") }}
      </span>
    </div>
    <div
      class="px-4 d-flex flex-column ai-center"
      style="max-height: 57rem; overflow-y: overlay"
    >
      <v-form
        v-if="step === 0"
        class="d-flex w-95 flex-column"
        v-model="formValid"
      >
        <div class="d-flex w-100">
          <div class="d-flex flex-column w-50 px-5">
            <label class="mb-1 fw-weight">
              {{ $t("detail.account") }}
            </label>
            <v-text-field
              background-color="#fbfbfb"
              v-model="user.account"
              color="#181C24"
              solo
              flat
              disabled
            ></v-text-field>
          </div>
          <div class="d-flex flex-column w-50 px-5">
            <label class="mb-1 fw-weight">
              {{ $t("detail.telephone") }}
            </label>
            <v-text-field
              v-model="detail.telephone"
              :rules="[rules.required]"
              background-color="#fbfbfb"
              color="#181C24"
              solo
              flat
            ></v-text-field>
          </div>
        </div>
        <div class="d-flex w-100">
          <div class="d-flex flex-column w-50 px-5">
            <label class="mb-1 fw-weight">
              {{ $t("detail.chineseName") }}
            </label>
            <v-text-field
              v-model="detail.recipient"
              :rules="[rules.required]"
              background-color="#fbfbfb"
              color="#181C24"
              solo
              flat
            ></v-text-field>
          </div>
          <div class="d-flex flex-column w-50 px-5">
            <label class="mb-1 fw-weight">
              {{ $t("detail.email") }}
            </label>
            <v-text-field
              v-model="detail.email"
              :rules="[rules.required]"
              background-color="#fbfbfb"
              color="#181C24"
              solo
              flat
            ></v-text-field>
          </div>
        </div>
        <div class="d-flex w-100">
          <div class="d-flex flex-column w-100 px-5">
            <label class="mb-1 fw-weight">
              {{ $t("detail.address") }}
            </label>
            <v-text-field
              v-model="detail.address"
              :rules="[rules.required]"
              background-color="#fbfbfb"
              color="#181C24"
              solo
              flat
            ></v-text-field>
          </div>
        </div>
        <div class="d-flex w-100">
          <div class="d-flex flex-column w-50 px-5">
            <label class="mb-1 fw-weight">
              {{ $t("detail.invoiceType") }}
            </label>
            <v-select
              v-model="detail.duplicateInvoice"
              background-color="#fbfbfb"
              @change="changeInvoiceType"
              color="#181C24"
              :items="invoiceType"
              item-text="label"
              item-value="value"
              solo
              flat
            ></v-select>
          </div>
          <div class="d-flex flex-column w-50 px-5">
            <label class="mb-1 fw-weight">
              {{ $t("detail.selectMaker") }}
            </label>
            <v-select
              v-model="detail.selectManager"
              :items="detail.managers"
              @change="changeMaker"
              item-text="account"
              item-value="managerId"
              background-color="#fbfbfb"
              color="#181C24"
              solo
              flat
            ></v-select>
          </div>
        </div>
        <div class="d-flex w-100">
          <div class="d-flex flex-column w-50 px-5">
            <label class="mb-1 fw-weight">
              {{ $t("detail.invoiceTitle") }}
            </label>
            <v-text-field
              v-model="detail.company"
              background-color="#fbfbfb"
              color="#181C24"
              solo
              flat
            ></v-text-field>
          </div>
          <div
            v-if="!detail.duplicateInvoice"
            class="d-flex flex-column w-50 px-5"
          >
            <label class="mb-1 fw-weight">
              {{ $t("detail.taxId") }}
            </label>
            <v-text-field
              v-model="detail.taxId"
              background-color="#fbfbfb"
              color="#181C24"
              solo
              flat
            ></v-text-field>
          </div>
        </div>
        <div class="d-flex w-100">
          <div class="d-flex flex-column w-100 px-5">
            <label class="mb-1 fw-weight">
              {{ $t("detail.note") }}
            </label>
            <v-textarea
              v-model="detail.note"
              background-color="#fbfbfb"
              color="#181C24"
              :rows="3"
              solo
              flat
            ></v-textarea>
          </div>
        </div>
      </v-form>
      <div
        v-else-if="step === 1"
        class="d-flex w-90 ai-center flex-column mb-3 py-8 check-order"
      >
        <div class="d-flex jc-center">
          <div class="d-flex">
            <span class="disperse w-90">
              {{ $t("detail.account") }}
            </span>
            <span>：</span>
          </div>
          <span class="ml-14">{{ user.account }}</span>
        </div>
        <div class="d-flex jc-center">
          <div class="d-flex">
            <span class="disperse w-90">
              {{ $t("detail.telephone") }}
            </span>
            <span>：</span>
          </div>
          <span class="ml-14">{{ newOrder.telephone }}</span>
        </div>
        <div class="d-flex jc-center">
          <div class="d-flex">
            <span class="disperse w-90">
              {{ $t("detail.email") }}
            </span>
            <span>：</span>
          </div>
          <span class="ml-14">{{ newOrder.email }}</span>
        </div>
        <div class="d-flex jc-center">
          <div class="d-flex">
            <span class="disperse w-90">
              {{ $t("detail.chineseName") }}
            </span>
            <span>：</span>
          </div>
          <span class="ml-14">{{ newOrder.recipient }}</span>
        </div>
        <div class="d-flex jc-center">
          <div class="d-flex">
            <span class="disperse w-90">
              {{ $t("detail.address") }}
            </span>
            <span>：</span>
          </div>
          <span class="ml-14">{{ newOrder.address }}</span>
        </div>
        <div class="d-flex jc-center">
          <div class="d-flex">
            <span class="disperse w-90">
              {{ $t("detail.invoiceType") }}
            </span>
            <span>：</span>
          </div>
          <span class="ml-14">
            <span v-if="newOrder.duplicateInvoice">
              {{ $t("detail.duplicateInvoice") }}
            </span>
            <span v-else>
              {{ $t("detail.triplicateInvoice") }}
            </span>
          </span>
        </div>
        <div class="d-flex jc-center" v-if="!detail.duplicateInvoice">
          <div class="d-flex">
            <span class="disperse w-90">
              {{ $t("detail.taxId") }}
            </span>
            <span>：</span>
          </div>
          <span class="ml-14">{{ newOrder.taxId }}</span>
        </div>
        <div class="d-flex jc-center">
          <div class="d-flex">
            <span class="disperse w-90">
              {{ $t("detail.invoiceTitle") }}
            </span>
            <span>：</span>
          </div>
          <span class="ml-14">{{ newOrder.company }}</span>
        </div>
        <div class="d-flex jc-center">
          <div class="d-flex">
            <span class="disperse w-90">
              {{ $t("detail.selectMaker") }}
            </span>
            <span>：</span>
          </div>
          <span class="ml-14">{{
            detail.managers[newOrder.managerId].account
          }}</span>
        </div>
        <div class="d-flex jc-center">
          <div class="d-flex">
            <span class="disperse w-90">
              {{ $t("detail.note") }}
            </span>
            <span>：</span>
          </div>
          <span style="white-space: pre-wrap;" class="ml-14">{{
            newOrder.note
          }}</span>
        </div>
      </div>
      <div
        v-else-if="step === 2"
        class="d-flex w-90 ai-center flex-column mb-4 check-order"
        style="padding-top: 4.7rem; padding-bottom:4.7rem"
      >
        <img
          src="/assets/bg/order_confirm.png"
          alt="order_complete"
          style="width: 17.5rem;"
        />
      </div>
      <div
        v-if="step !== 2"
        class="d-flex jc-between mt-2"
        style="width: 22rem;"
      >
        <v-btn
          v-if="step === 0"
          dark
          outlined
          x-large
          class="detail-btn"
          color="orange"
          :to="`/${this.$i18n.locale}/order/cart?back=true`"
          @click="backToCart"
        >
          {{ $t("detail.backToCart") }}
        </v-btn>
        <v-btn
          :loading="loadingStep"
          v-if="step === 1"
          dark
          outlined
          x-large
          class="detail-btn"
          color="orange"
          @click="step = 0"
        >
          {{ $t("detail.previousStep") }}
        </v-btn>
        <v-btn
          :loading="loadingStep"
          dark
          x-large
          depressed
          class="detail-btn"
          color="orange"
          @click="nextStep"
        >
          {{ $t("detail.nextStep") }}
        </v-btn>
      </div>
      <div v-else class="d-flex jc-between mt-2">
        <v-btn
          dark
          x-large
          depressed
          class="detail-btn"
          color="orange"
          :to="`/${this.$i18n.locale}/order/cart`"
        >
          {{ $t("detail.backToCart") }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      loadingStep: false,
      step: 0,
      formValid: false,
      rules: {
        required: value => !!value || this.$t("errorMessage.required")
      },
      detail: {
        duplicateInvoice: true,
        taxId: "",
        telephone: "",
        note: "",
        email: "",
        address: "",
        company: "",
        recipient: "",
        managers: [],
        managerId: null,
        selectManager: null
      },
      scrollOptions: {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic"
      }
    };
  },
  computed: {
    ...mapState(["newOrder"]),
    ...mapState(["user"]),
    invoiceType() {
      return [
        { label: this.$t("detail.duplicateInvoice"), value: true },
        { label: this.$t("detail.triplicateInvoice"), value: false }
      ];
    }
  },
  methods: {
    ...mapMutations("newOrder", ["setInfo", "clearOrder"]),
    ...mapActions("user", ["getUser"]),
    ...mapActions("snackbar", ["openSnackbar"]),
    backToCart() {
      console.log("back");
    },
    changeInvoiceType() {
      if (this.detail.duplicateInvoice) this.detail.company = this.user.name;
      else this.detail.company = this.user.company;
    },
    changeMaker() {
      this.detail.managerId = this.detail.selectManager;
    },
    async nextStep() {
      this.loadingStep = true;
      if (this.step === 0) {
        this.setInfo(this.detail);
        this.step++;
      } else {
        await this.$http
          .post("orders", this.newOrder)
          .then(() => {
            this.step++;
          })
          .catch(() => {
            console.log("error");
          });
      }
      this.loadingStep = false;
      this.$vuetify.goTo(100);
    },
    initDetail() {
      this.detail.taxId = this.user.taxId;
      this.detail.recipient = this.user.name;
      this.detail.telephone = this.user.telephone;
      this.detail.company = this.user.name;
      this.detail.email = this.user.email;
      this.detail.address = this.user.address;
      this.detail.note = this.user.note;
    }
  },
  async created() {
    if (this.newOrder.confirmItems.length <= 0)
      this.$router.push(`/${this.$i18n.locale}/order/cart`);
    await this.getUser();
    this.initDetail();

    const res = await this.$http.get("shippingFees/Managers");
    this.detail.managers = res.data;
  },
  mounted() {
    this.$vuetify.goTo("#scrollTo", this.scrollOptions);
  }
};
</script>

<style lang="sass" scoped>
.dot-title
  padding-top: 2.2rem
  padding-bottom: 0.55rem
  margin-bottom: 3rem
  font-size: 2.75rem
  color: #ffa20a
  letter-spacing: 0.4585rem
  text-indent: 0.4585rem
  border-bottom: 2px dashed #ffa20a

::v-deep .v-input__slot
  border: 1px solid rgba(80,87,95,0.20) !important
  font-size: 1rem

.detail-btn
  min-width: 8rem !important
  border-radius: 0.5rem

.check-order
  background: #FBFBFB
  border: 1px solid rgba(80, 87, 95, 0.20)
  border-radius: 3px
  > div
    margin-bottom: 0.8rem
    > div
      min-width: 5rem
      color: #979797
    > span
      width: 25rem
</style>
